export default {
  /**
   * 日付バリデーション
   * @param  {String}  text 日付
   * @return {Boolean}
   */
  isValidDate(text) {
    if (!text) return true
    if (!/^\d{1,4}(\/|-)\d{1,2}\1\d{1,2}$/.test(text)) {
      return false
    }

    const [year, month, day] = text.split(/\/|-/).map((v) => parseInt(v, 10))
    const date = new Date(year, month - 1, day)

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    )
  },
  /**
   * TELバリデーション
   * @param  {String}  text TEL,FAX
   * @return {Boolean}
   */
  isValidTel(text) {
    if (!text) return true
    const tel = text.replace(/-/g, '')
    if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7,11})$/)) {
      return false
    }
    return true
  },
  /**
   * 時刻バリデーション
   * @param  {String}  text 時刻
   * @return {Boolean}
   */
  isValidTime(text) {
    return text.match(/^([01]?[0-9]|2[0-3]):([0-5][0-9])$/) !== null
  },
  /**
   * パスワードバリデーション
   * @param  {String}  text PASSWORD
   * @return {Boolean}
   */
  isValidPassword(password) {
    const psw = password
    if (!psw) return false
    if (!psw.match(/[A-Za-z]/gi)) {
      return false
    } else if (!psw.match(/[0-9]/gi)) {
      return false
    }
    return true
  },
  /**
   * 全角バリデーション
   * @param  {String}  text val
   * @return {Boolean}
   */
  isZenkaku(val) {
    if (!val) return true
    return !String(val).match(/[\x01-\x7E\uFF65-\uFF9F]/)
  },
  /**
   * 絵文字バリデーション
   * @param  {String}  text val
   * @return {Boolean}
   */
  isEmoji(val) {
    const ranges = [
      '\ud83c[\udf00-\udfff]',
      '\ud83d[\udc00-\ude4f]',
      '\ud83d[\ude80-\udeff]',
      '\ud7c9[\ude00-\udeff]',
      '[\u2600-\u27BF]',
    ]
    const reg = new RegExp(ranges.join('|'), 'g')
    return !reg.test(val)
  },
}



// WEBPACK FOOTER //
// ./src/valid.js